import axios from 'axios';
import Wix from './Wix';
import { getContext } from './utils';

const request = axios.create();

request.interceptors.request.use(config => {
  const context = getContext();

  const extraParams = {
    'wix-comp-id': Wix.Utils.getCompId(),
    'wix-instance': context.instance,
    'wix-app': context.app
  };

  if (Wix.Utils.getOrigCompId()) {
    extraParams['wix-orig-comp-id'] = Wix.Utils.getOrigCompId();
  }

  if (context.originCompId) {
    extraParams['wix-origin-comp-id'] = context.originCompId;
  }

  if (config.method === 'post' || config.method === 'put') {
    config.headers = Object.assign({}, config.headers || {}, extraParams);
  } else {
    config.params = Object.assign({}, config.params || {}, extraParams);
  }

  if (process.env.REACT_APP_API_URL) {
    config.url = `${process.env.REACT_APP_API_URL}` + config.url;
  }

  return config;
});

export default request;



// WEBPACK FOOTER //
// ./src/commons/services/request.js